import { Container } from "@mui/material";
import Screen from "../../components/layout/Screen";
import TitledHeader from "../../components/layout/TitledHeader";
import LoanDrawRequestForm from "../../forms/LoanDrawRequestForm";

const DrawRequestScreen = () => {
  return (
    <Screen
      sx={{
        position: "absolute",
        left: 0,
        width: "100%",
        height: "100vh",
      }}
    >
      <TitledHeader
        title={"Submit Draw Request"}
        description="Please select the loan you want to draw from and provide the necessary details."
      />

      <Container maxWidth="md" sx={{ py: 3 }}>
        <LoanDrawRequestForm />
      </Container>
    </Screen>
  );
};

export default DrawRequestScreen;
